import React, { useState, useEffect } from "react"
import { RiFilterOffLine } from "react-icons/ri";
import { BsEyeFill } from "react-icons/bs";
import { FaFileDownload } from "react-icons/fa";
import User from "../User"
import Payment from "../Payment"
import ReactPaginate from "react-paginate";
import moment from "moment"
import momenttz from 'moment-timezone';
import "./Table.scss"
import DateInput, { DateContext } from "../inputs/DateInput";
import { Button, Container, ContainerDate, ContainerInput, DateFilter, DocumentContainer, DocumentFilter, TableBody, TableData, TableHead, TableHeadData, TableHeader, TableLog, TableRow, Title } from "./styles";
import GenericButton from "../buttons/GenericButton";
import Account from "../Account";
import { Link } from "react-router-dom";
import formatCurrency from "../../utils/formatCurrency";
import translatePaymentMethod from "../../utils/translatePaymentMethod";
import addMaskToDocument from "../../utils/addMaskToDocument";
import { useCallback } from "react";
import { LoadingIcon } from "../LoadingIcon";
import { Checkbox } from "../Checkbox";
import DownloadLoader from "../DownloadLoader";
import { documentMask } from "../../utils/inputMask";

const STORAGE_KEYS = {
    START: "logger_start_date",
    END: "logger_end_date",
    DOCUMENT: "logger_document"
};

export const Table = () => {
    const [dateStart, setDateStart] = useState(moment().subtract(1, 'days').startOf('day').format("YYYY-MM-DDTHH:mm"));
    const [dateEnd, setDateEnd] = useState(moment().format("YYYY-MM-DDTHH:mm"))
    const { dateStartP, setDateStartP, dateEndP, setDateEndP } = React.useContext(DateContext);

    const paginationPage = sessionStorage.getItem('paginationPage');
    const selectedPayment = sessionStorage.getItem('paymentOption');
    const storedDocument = sessionStorage.getItem('document');

    const [paymentOption, setPaymentOption] = useState(selectedPayment || "creditcard")
    const [itemsList, setItemsList] = useState([])
    const [currentPage, setCurrentPage] = useState(paginationPage || 1);
    const [noPageFilter, setNoPageFilter] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [countRender, setCountRender] = useState(0);

    const [documentFilter, setDocumentFilter] = useState(storedDocument || null);

    const [loading, setLoading] = useState(false);
    const [downloading, setDownloading] = useState(false);

    const itemListArr = []
    const url = `${process.env.REACT_APP_URL}/api/v1/logger`

    const handleFetch = useCallback(async (page = currentPage, isExport = false) => {
        setLoading(!isExport);

        const utcStart = momenttz.tz(dateStartP, "America/Sao_Paulo");
        const utcEnd = momenttz.tz(dateEndP, "America/Sao_Paulo");

        let endpoint = isExport ? `${url}/download/` : `${url}/`;
        endpoint += `?paymentMethod=${paymentOption}`;
        if (!isExport && !noPageFilter) endpoint += `&page=${page}`;
        endpoint += `&startDate=${utcStart.format()}&endDate=${utcEnd.format()}`;
        if (documentFilter) endpoint += `&document=${documentFilter}`;

        try {
            const headers = {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            };

            if (isExport) {
                const res = await fetch(endpoint, { headers });
                const blob = await res.blob();
                const urlBlob = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = urlBlob;
                a.download = "payments-logs.xlsx";
                document.body.appendChild(a);
                a.click();
                a.remove();
                setDownloading(false);
            } else {
                const res = await fetch(endpoint, { headers });
                const data = await res.json();
                setItemsList(data.payments || []);
                setCurrentPage(data.currentPage || 1);
                setTotalPages(data.totalPages || 1);
                setLoading(false);
            }
        } catch (err) {
            console.error("Erro ao buscar logs", err);
            setLoading(false);
            setDownloading(false);
        }
    }, [paymentOption, noPageFilter, documentFilter]);

    useEffect(() => {
        handleFetch(currentPage);
    }, [handleFetch]);

    // const verifyDate = useCallback(() => {
    //     if (moment(dateStart).isAfter(dateEnd)) {
    //         restartDateFunction()
    //     } else {
    //         setDateStart(moment(dateStart).format())
    //         setDateEnd(moment(dateEnd).format())
    //     }


    //     setCountRender(oldCountRender => {
    //         return [oldCountRender + 1]
    //     });
    // }, [dateEnd, dateStart])

    const verifyDate = useCallback(() => {
        if (moment(dateStartP).isAfter(dateEndP)) {
            restartDateFunction();
        }

        setCountRender(oldCountRender => oldCountRender + 1);
    }, [dateStartP, dateEndP]);

    // const handleSearch = useCallback((dateStartP, dateEndP, nextPage = 1) => {
    //     setLoading(true);

    //     const utcStartDate = momenttz.tz(dateStartP, 'America/Sao_Paulo');
    //     const utcEndDate = momenttz.tz(dateEndP, 'America/Sao_Paulo');

    //     setDateStart(moment(utcStartDate).format());
    //     setDateEnd(moment(utcEndDate).format());

    //     verifyDate();
    //     fetch(`${url}/?paymentMethod=${paymentOption}${noPageFilter ? '' : '&page=' + nextPage || currentPage}&startDate=${moment(utcStartDate).format()}&endDate=${moment(utcEndDate).format()}${documentFilter ? '&document=' + documentFilter : ''}`, {
    //         method: "GET",
    //         headers: {
    //             Authorization: `Bearer ${localStorage.getItem("token")}`
    //         }
    //     })
    //         .then((res) => res.json()
    //         ).then(data => {

    //             data.payments.forEach(obj => {
    //                 itemListArr.push(obj)
    //             })
    //             setCurrentPage(data.currentPage)
    //             setTotalPages(data.totalPages)
    //             setItemsList(() => {
    //                 return [...itemListArr]
    //             });
    //             setLoading(false);

    //         })
    // }, [itemListArr, url, verifyDate, currentPage, paymentOption, noPageFilter])

    const handleSearch = useCallback((start = dateStartP, end = dateEndP, nextPage = 1) => {
        setLoading(true);

        const utcStartDate = momenttz.tz(start, 'America/Sao_Paulo');
        const utcEndDate = momenttz.tz(end, 'America/Sao_Paulo');

        verifyDate();

        fetch(`${url}/?paymentMethod=${paymentOption}${noPageFilter ? '' : '&page=' + nextPage}&startDate=${utcStartDate.format()}&endDate=${utcEndDate.format()}${documentFilter ? '&document=' + documentFilter : ''}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        })
            .then(res => res.json())
            .then(data => {
                setItemsList(data.payments || []);
                setCurrentPage(data.currentPage);
                setTotalPages(data.totalPages);
                setLoading(false);
            });
    }, [url, verifyDate, currentPage, paymentOption, noPageFilter, documentFilter, dateStartP, dateEndP]);



    // function handleDownload(dateStart, dateEnd, isNoPageFilter = false) {
    //     const allLogs = JSON.parse(document.querySelector(`#baixar-todas-as-paginas`)?.value)
    //     const utcStartDate = momenttz.tz(dateStartP, 'America/Sao_Paulo');
    //     const utcEndDate = momenttz.tz(dateEndP, 'America/Sao_Paulo');
    //     !!allLogs && setDownloading(true);

    //     fetch(`${url}/download/?paymentMethod=${paymentOption}${noPageFilter || allLogs ? '' : '&page=' + currentPage + '&size=150'}&startDate=${moment(utcStartDate).format()}&endDate=${moment(utcEndDate).format()}${documentFilter ? '&document=' + documentFilter : ''}`, {
    //         method: "GET",
    //         headers: {
    //             Authorization: `Bearer ${localStorage.getItem("token")}`
    //         }
    //     })
    //         .then((res) => res.blob())
    //         .then(res => {
    //             const urlBlob = window.URL.createObjectURL(res)
    //             const a = document.createElement("a")
    //             a.href = urlBlob
    //             a.download = "payments-logs.xlsx"
    //             document.body.appendChild(a)
    //             a.click()
    //             a.remove()
    //             setDownloading(false);

    //         })
    // }

    function handleDownload(isNoPageFilter = false) {
        const allLogs = JSON.parse(document.querySelector(`#baixar-todas-as-paginas`)?.value);
        const utcStartDate = momenttz.tz(dateStartP, 'America/Sao_Paulo');
        const utcEndDate = momenttz.tz(dateEndP, 'America/Sao_Paulo');
        !!allLogs && setDownloading(true);

        fetch(`${url}/download/?paymentMethod=${paymentOption}${isNoPageFilter || allLogs ? '' : '&page=' + currentPage + '&size=150'}&startDate=${utcStartDate.format()}&endDate=${utcEndDate.format()}${documentFilter ? '&document=' + documentFilter : ''}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        })
            .then((res) => res.blob())
            .then(res => {
                const urlBlob = window.URL.createObjectURL(res);
                const a = document.createElement("a");
                a.href = urlBlob;
                a.download = "payments-logs.xlsx";
                document.body.appendChild(a);
                a.click();
                a.remove();
                setDownloading(false);
            });
    }


    const handlePayment = (option) => {
        setCurrentPage(oldCurrentPage => {
            return [1]
        });
        setPaymentOption(option.value)

        sessionStorage.setItem('paymentOption', option.value);
    }

    // function restartDateFunction() {
    //     setDateStart(moment().subtract(1, 'days').startOf('day').format("YYYY-MM-DDTHH:mm"));
    //     setDateEnd(moment().format("YYYY-MM-DDTHH:mm"))

    //     setCountRender(oldCountRender => {
    //         return [oldCountRender + 1]
    //     });
    // }

    function restartDateFunction() {
        const defaultStart = moment().subtract(1, 'days').startOf('day').format("YYYY-MM-DDTHH:mm");
        const defaultEnd = moment().format("YYYY-MM-DDTHH:mm");

        setDateStartP(defaultStart);
        setDateEndP(defaultEnd);

        setCountRender(old => old + 1);
    }



    const [columnKeys, columnValues] = (() => {
        const columns = {
            "fullBody": "-",
            "date": "Data",
            "document": "CPF/CNPJ",
            "logged": "Logado",
            "environment": "Ambiente",
            "frequency": "Frequência",
            "campaignId": "CampaignId",
            // "selectedChannel": "Canal Selecionado",
            "totalValue": "Valor Total",
            "vindiStatus": "Vindi Status",
            "donationType": "Tipo de doação",
            "paymentType": "Tipo de pagamento"
        }

        return [Object.keys(columns), Object.values(columns)]
    })()

    // const { dateStartP, dateEndP } = React.useContext(DateContext);

    const handlePageClick = useCallback((event, isNoPageFilter = false) => {
        let page = 0;

        if (isNoPageFilter) {
            setNoPageFilter(true);
            handleSearch(dateStartP, dateEndP, page);
            return;
        }


        page = event.selected + 1;
        setNoPageFilter(false);
        handleSearch(dateStartP, dateEndP, page);
        setCurrentPage(page);

        sessionStorage.setItem('paginationPage', page);
    }, [dateStartP, dateEndP, handleSearch]);


    const handleDocumentFilter = useCallback((document) => {
        const currentText = documentMask(document);
        setDocumentFilter(currentText);
        sessionStorage.setItem('document', document);
    }, []);

    const MAX_DOCUMENT_LENGTH = 18;

    return (
        <Container>
            <TableHeader>
                <DateFilter>
                    <RiFilterOffLine title="Remover Filtro" onClick={restartDateFunction} />

                    <ContainerInput>
                        <ContainerDate>
                            <DateInput label={'Data Inicial'} />
                            <DateInput label={'Data Final'} startInput={false} />
                        </ContainerDate>
                        <DocumentContainer>
                            <Title>Documento</Title>
                            <DocumentFilter
                                onChange={(e) => handleDocumentFilter(e.target.value)}
                                value={documentFilter}
                                maxLength={MAX_DOCUMENT_LENGTH}
                                placeholder={'CPF/CNPJ'}
                            />
                        </DocumentContainer>
                    </ContainerInput>


                    <GenericButton clickFunction={() => handleSearch(dateStartP, dateEndP)} buttonText={"Buscar"} />
                </DateFilter>

                <Payment handlePayment={handlePayment} selectedPayment={selectedPayment} />
                <Checkbox label={'Baixar Todas as Páginas'} />
                <FaFileDownload id="btn" className="downloadBtn" title="baixar planilha" onClick={() => handleDownload(dateStartP, dateEndP)} />

                <Account />
            </TableHeader>

            <TableLog>
                <TableHead>
                    <TableRow>
                        {
                            columnKeys.map((column, i) => (
                                <TableHeadData
                                    className={`${column} ${i === 0 ? 'first-column' : ''}`}
                                    key={column}
                                >
                                    {columnValues[i]}
                                </TableHeadData>
                            ))
                        }
                    </TableRow>
                </TableHead>


                {loading ? (
                    <LoadingIcon />
                ) : (
                    <TableBody>
                        {
                            itemsList.map((log, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableData className="fullBody first-column">
                                            <Link to={`/logger/id/${log.id}`}>
                                                <BsEyeFill />
                                            </Link>
                                        </TableData>

                                        <TableData className="date">{moment(log.createdAt).format("DD/MM/YYYY HH:mm")}</TableData>

                                        <TableData className="document">{addMaskToDocument(log.body.customer.document)}</TableData>
                                        <TableData className="logged">{log.body.logged ? "Sim" : "Não"}</TableData>
                                        <TableData className="environment">{log.body.environment}</TableData>
                                        <TableData className="frequency">{log.body.frequency === "unique" ? "Única" : "Mensal"}</TableData>
                                        <TableData className="campaignId">{log.body.CampaignId}</TableData>
                                        {/* <TableData className="selectedChannel">{log.body.customer.channel_selected}</TableData> */}
                                        <TableData className="totalValue">{formatCurrency(log.body.orderTotal)}</TableData>
                                        <TableData className="vindiStatus">{String(log.vindi_status < 400)}</TableData>
                                        <TableData className="donationType">{log.body.type_donation}</TableData>
                                        <TableData className="paymentType" >{translatePaymentMethod(log.payment_method)}</TableData>
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                )}
            </TableLog>

            <DownloadLoader downloading={downloading} />

            <ReactPaginate
                pageCount={totalPages}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                breakClassName={"page-item"}
                pageClassName={"ul-link"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item disabled"}
                nextClassName={"page-item disabled"}
                forcePage={currentPage -1}
            />
        </Container>

    )
}
